import { quickProperty, designToken } from '../component-tokens';
import { borderBase, focusState } from './common';
export const switchTokens = {
    // Adding '-component' to avoid system name conflict
    name: 'switch-component',
    tag: 'chameleon-switch',
    reactImports: 'Switch',
    children: [
        {
            name: 'default',
            attributes: Object.assign(Object.assign({}, borderBase), { 'border-color': quickProperty('transparent'), position: quickProperty('relative'), width: designToken('spacing-08'), height: designToken('spacing-05'), background: designToken('surface-color-tertiary'), 'box-sizing': quickProperty('border-box'), 'border-radius': designToken('radius-large'), cursor: quickProperty('pointer'), transition: quickProperty('all 0.25s ease-out') }),
            children: [
                {
                    name: 'knob',
                    attributes: {
                        position: quickProperty('absolute'),
                        content: quickProperty(''),
                        background: designToken('icon-color-inverted'),
                        'border-radius': designToken('radius-circle'),
                        'box-shadow': designToken('elevation-small'),
                        width: designToken('spacing-04'),
                        height: designToken('spacing-04'),
                        transform: quickProperty('translate(1px, 1px)'),
                        transition: quickProperty('all 70ms cubic-bezier(0.4, 0.14, 0.3, 1)'),
                    },
                },
                {
                    name: 'label',
                    attributes: {
                        font: designToken('body-small'),
                        color: designToken('type-color-default'),
                    },
                },
                {
                    name: 'focus',
                    attributes: {
                        outline: quickProperty('none'),
                    },
                },
                {
                    name: 'focus-visible',
                    attributes: Object.assign({}, focusState),
                },
            ],
        },
    ],
    variants: [
        {
            name: 'checked',
            attributes: {
                background: designToken('interactive-color-brand-default'),
            },
            children: [
                {
                    name: 'knob',
                    attributes: {
                        transform: quickProperty('translate(21px, 1px)'),
                    },
                },
            ],
        },
        {
            name: 'disabled',
            attributes: {
                cursor: quickProperty('not-allowed'),
                background: designToken('interactive-color-disabled'),
            },
            children: [
                {
                    name: 'knob',
                    attributes: {
                        'box-shadow': quickProperty('none'),
                        background: designToken('icon-color-inverted'),
                    },
                },
            ],
        },
    ],
};
